import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 行业管理 — 通用版.
 * 真正的多语言名称/描述编辑由 src/pages/industries/Form.tsx 提供 (多 Tab 富表单);
 * 这里只保留只读列, 给习惯 ProTable 风格的同学一个一致入口.
 */
export const industriesConfig: CrudConfig = {
  resource: 'industries',
  title: '行业管理',
  rowKey: 'id',
  searchFields: ['code', 'status'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'code', label: '行业代码', type: 'text', required: true, copyable: true, width: 160 },
    { name: 'display_name', label: '名称', type: 'readonly', ellipsis: true, hideInForm: true, readonly: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      required: true,
      width: 120,
      options: [
        { label: '活跃', value: 'ACTIVE', status: 'Success', color: 'green' },
        { label: '未激活', value: 'INACTIVE', status: 'Default' },
        { label: '即将上线', value: 'COMING_SOON', status: 'Processing', color: 'blue' },
        { label: '已弃用', value: 'DEPRECATED', status: 'Error', color: 'red' },
      ],
    },
    { name: 'color', label: '主题色', type: 'text', width: 120, placeholder: '#1677ff' },
    { name: 'icon', label: '图标', type: 'text', hideInTable: true },
    { name: 'sort', label: '排序', type: 'number', width: 80, hideInSearch: true },
    { name: 'user_count', label: '用户数', type: 'readonly', width: 100, hideInForm: true, readonly: true },
  ],
};
